import { buffer, createEmpty, extendXY } from 'ol/extent';
/** Bounding box of a polygon as `[minX, minY, maxX, maxY]`, optionally padded. */
export function extentFromPolygon(polygon, pad = 0) {
    const extent = createEmpty();
    for (const [x, y] of polygon)
        extendXY(extent, x, y);
    return pad === 0 ? extent : buffer(extent, pad);
}
/**
 * Transform an extent by sampling along all 4 edges, not just corners.
 * Produces an accurate bounding box for non-affine projections. Returns
 * `[NaN, NaN, NaN, NaN]` if every sampled point fails to transform.
 */
export function transformExtentSampled(extent, transformFn, samples = 8) {
    const [minX, minY, maxX, maxY] = extent;
    const out = createEmpty();
    const update = (xy) => {
        const x = xy[0];
        const y = xy[1];
        if (x === undefined || y === undefined)
            return;
        if (!isFinite(x) || !isFinite(y))
            return;
        extendXY(out, x, y);
    };
    for (let i = 0; i <= samples; i++) {
        const t = i / samples;
        const x = minX + t * (maxX - minX);
        const y = minY + t * (maxY - minY);
        update(transformFn([x, minY], undefined, 2));
        update(transformFn([x, maxY], undefined, 2));
        update(transformFn([minX, y], undefined, 2));
        update(transformFn([maxX, y], undefined, 2));
    }
    if (!isFinite(out[0]))
        return [NaN, NaN, NaN, NaN];
    return out;
}
//# sourceMappingURL=geo.js.map